// components/WhyChooseSection.js
import React from 'react';
import './WhyChooseSection.css';

const WhyChooseSection = () => {
  const features = [
    {
      id: 1,
      icon: '📅',
      title: 'Easy Slot Booking',
      description:
        'Reserve your preferred car wash, turf, or tournament in just a few taps. No calls, no waiting — just smooth scheduling.',
    },
    {
      id: 2,
      icon: '✅',
      title: 'Verified Partners',
      description:
        'All service providers on QSlot are verified for quality and reliability. Book with confidence, every time.',
    },
    {
      id: 3,
      icon: '🏆',
      title: 'Real-Time Tournaments',
      description:
        'Get live updates, register instantly, and stay informed about match timings — all in real time.',
    },
  ];

  return (
    <section className="why-choose-section" id="why">
      <div className="why-choose-container">
        {/* Section Header */}
        <div className="why-choose-header">
          <span className="why-choose-tag">WHY QSLOT</span>
          <h2 className="why-choose-title">
            Why Choose <span className="why-choose-title-highlight">QSlot?</span>
          </h2>
          <p className="why-choose-subtitle">
            Discover the benefits that make QSlot the preferred choice for
            thousands of users
          </p>
        </div>

        {/* Features Grid */}
        <div className="why-choose-grid">
          {features.map((feature) => (
            <div key={feature.id} className="why-choose-card">
              <div className="why-choose-icon-wrapper">
                <span className="why-choose-icon">{feature.icon}</span>
              </div>
              <h3 className="why-choose-card-title">{feature.title}</h3>
              <p className="why-choose-card-description">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;